import './quiz_result.scss';
import './img/meetup-conference-cam.png';



// WEBPACK FOOTER //
// ./resources/views/partials/quiz_type/result/quiz_result.js